module.exports = __webpack_public_path__ + "img/noGood.92cb6661.png";